/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useRef } from 'react';
import jsonData from '../../Utils/farmerImagesName.json';
import html2canvas from 'html2canvas';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getCookie } from '../../Utils/cookies';
import JSZip from "jszip";
import { saveAs } from "file-saver";

function importAllImages(r) {
  return r.keys().map(r);
}

const Images = importAllImages(require.context('../../Assets/farmerPumpImages', false, /\.(png|jpe?g)$/));

const Index = () => {

  const Navigate = useNavigate();

  useEffect(() => {
    const token = getCookie('token');
    if (!token) {
      Navigate('/');
    }
  }, [Navigate]);

  console.log(Images);

  const refs = useRef([]);
  const totalImages = Images.length;
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [finalData, setFinalData] = useState([]);
  const [selectedImages, setSelectedImages] = useState(Array(120).fill(true));
  const [ startBatch, setStartBatch ] = useState(0);
  const [ endBatch, setEndBatch ] = useState(120);

  const fetchData = async (index) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/pump/showFarmer`, {
        imageSaralId: jsonData[startBatch + index].original.split(".")[0],
      });
      const responseData = response.data;
      if (responseData.success) {
        return responseData.data;
      }
    } catch (error) {
      console.error(`Error fetching data for index ${index}:`, error);
      return null;
    }
  };

  const fetchDataForSelectedImages = async () => {
    const requests = selectedImages.map((isSelected, index) => {
      if (isSelected) {
        return fetchData(index);
      }
      return null;
    });

    const results = await Promise.all(requests);
      return results.filter(Boolean);
    };


  const downloadImagesAsZip = async () => {
    setProgress(0);
    const zip = new JSZip();
    const imagesFolder = zip.folder("images");

    for (let i = 0; i < refs.current.length; i++) {
      const element = refs.current[i];
      if (element) {
        try {
          const canvas = await html2canvas(element);
          const dataURL = canvas.toDataURL("image/png");
          const base64Data = dataURL.split(",")[1];
          imagesFolder.file(`${jsonData[startBatch + i].original.split('.')[0]}.png`, base64Data, { base64: true });
          canvas.remove();
        } catch (error) {
          console.error(`Failed to process image ${i + 1}:`, error);
        }
      }
      setProgress(Math.round(((i + 1) / refs.current.length) * 100));
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });
    const objecURL = URL.createObjectURL(zipBlob);
    saveAs(zipBlob, "images.zip");
    URL.revokeObjectURL(objecURL);

    setIsDownloading(false);
    setProgress(0);
    refs.current = [];
    window.location.reload();
  };

  const handleDownload = async () => {
    // if (endOfCountOfDownloadedImages === totalImages) {
    //   alert('Login again to download');
    // }
    // else {
      setIsDownloading(true);
      const fetchedData = await fetchDataForSelectedImages();
      setFinalData(fetchedData);

      setTimeout(() => {
        downloadImagesAsZip();
      }, 100);
    // }
  };

  const handleChangeCheckBoxes = (index) => {
    const copyData = [...selectedImages];
    copyData[index] = !copyData[index];
    setSelectedImages(copyData);
  }

  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [file, setFile] = useState();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handlePreviousBatch = () => {
    if(startBatch === 0){
      return;
    }
    setStartBatch((prev) => prev - 120);
    setEndBatch((prev) => prev - 120);
  }

  const handleNextBatch = () => {
    if(endBatch >= totalImages){
      return;
    }
    setStartBatch((prev) => prev + 120);
    if (totalImages - endBatch >= 120) {
      setEndBatch((prev) => prev + 120);
    }
    else {
      setEndBatch(totalImages);
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please select a file to upload.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsUploading(true);
      setMessage('');
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/pump/excelUpload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setMessage(response.data.message);
    } catch (error) {
      console.log(error);
      setMessage('Error uploading file.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="container flex flex-col">
      <div className="mainHeading">
        <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg'>U<span className='text-lg'>PDATE</span> & D<span className='text-lg'>OWNLOAD</span> I<span className='text-lg'>MAGES</span></h1>
      </div>
      <div className="grid gap-3 m-6 md:grid-cols-4">
        <div>
          <div className='flex flex-row justify-between items-center'>
            <form onSubmit={handleSubmit} >
              <div>
                <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Choose File<span className='text-red-500 fixed h-3'>*</span></label>
                <input type="file" onChange={handleFileChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2 dark:bg-gray-700 " />
              </div>
              {message && (<p className="mt-4 ml-6 text-2xl text-left text-red-700"> {message} </p>)}
            </form>
            <div className='ml-2 mt-2.5'>
              <button type="submit" disabled={isUploading} className="text-dark bg-yellow-500 mt-4 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center" onChange={handleFileChange}>
                {isUploading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
          <div>
            <div>
              <fieldset style={{ marginTop: '0.5rem' }}>
                <legend className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Saral Id<span className='text-red-500 fixed h-3'>*</span></legend>
                <section className="h-56 overflow-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  {
                    jsonData.map(({ split }, index) => (
                      <div key={index} style={{ display: 'flex', width: 'min-content', gap: '4.5px' }}>
                        <input type="checkbox" name="district" id={split} value={index} style={{ width: 'min-content' }} onChange={() => handleChangeCheckBoxes(index)} checked={(index >= startBatch && index < endBatch) ? true : false} />
                        <label htmlFor={split} style={{ padding: '0px', fontSize: '12px', fontWeight: '400', width: 'max-content' }}>{split}</label>
                      </div>
                    ))
                  }
                </section>
              </fieldset>
            </div>
          </div>

          <div style={{ position: "fixed", bottom: -9999, left: -9999, zIndex: -999 }}>
            {finalData.map(({ saralId, beneficiaryName, installationDistrict, initialLongitude, initialLatitude, pumpCapacity, villageName }, index) => (
              <div
                ref={(el) => (refs.current[index] = el)}
                key={index}
                style={{
                  position: "relative",
                  opacity: 1,
                  pointerEvents: "none",
                }}
              >
                <img
                  src={Images[startBatch + index]}
                  alt="Image"
                  onLoad={(e) => {
                    const img = e.target;
                    const parentDiv = img.parentElement;
                    const naturalWidth = img.naturalWidth;
                    const naturalHeight = img.naturalHeight;

                    parentDiv.style.width = `${naturalWidth}px`;
                    parentDiv.style.height = `${naturalHeight}px`;

                    const overlayDiv = parentDiv.querySelector(".overlay");
                    if (overlayDiv) {
                      if(naturalWidth <= 500 && naturalHeight <= 350){
                        overlayDiv.style.width = `180px`;
                        overlayDiv.style.height = `90px`;
                        overlayDiv.style.fontSize = `7.5px`
                      }
                      else if (naturalHeight > 950 || naturalWidth > 1800) {
                        if (naturalWidth > 1800) {
                          overlayDiv.style.width = `560px`;
                        }
                        else {
                          overlayDiv.style.height = `300px`;
                          // overlayDiv.style.height = `290px`
                          overlayDiv.style.width = `550px`;
                        }
                        overlayDiv.style.fontSize = `24.5px`;
                      }
                      else {
                        overlayDiv.style.width = `550px`;
                        // overlayDiv.style.height = `200px`;
                        overlayDiv.style.height = `230px`;
                        overlayDiv.style.fontSize = `19px`;
                      }
                    }
                  }}
                />
                <div
                  className="overlay"
                  style={{ position: 'absolute', paddingLeft: 8, left: 0, bottom: 5, width: '480px', height: '200px', fontSize: '19px', background: 'rgba(200, 200, 200, 1)', color: '#000' }}
                >
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Latitude: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{initialLatitude}</span>
                  </div>
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Longitude: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{initialLongitude}</span>
                  </div>
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Saral Id: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{saralId}</span>
                  </div>
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Farmer Name: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{beneficiaryName}</span>
                  </div>
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>District: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{installationDistrict}</span>
                  </div>
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>pumpCapacity: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{pumpCapacity}</span>
                  </div>
                  <div>
                    <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>villageName: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{villageName}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className='flex flex-row gap-2'>
              <button 
                className="w-full bg-yellow-500 mt-4 text-center text-dark font-medium rounded-sm text-sm px-5 py-2.5 cursor-pointer"
                onClick={handlePreviousBatch}
                disabled={isDownloading}
              >
                Previous Batch
              </button>
              <button 
                className="w-full bg-yellow-500 mt-4 text-dark text-center font-medium rounded-sm text-sm px-5 py-2.5 cursor-pointer"
                onClick={handleNextBatch}
                disabled={isDownloading}
              >Next Batch
              </button>
          </div>
          <button
            onClick={handleDownload}
            disabled={isDownloading}
            className="w-full bg-yellow-500 mt-4 text-dark font-medium rounded-sm text-sm px-5 py-2.5 cursor-pointer"
          >
            {isDownloading ? `Downloading... ${progress}%` : "Download Images"}
          </button>
          <span className='font-semibold'>Selected Images from <span className='italic'>{startBatch}-{endBatch}</span></span>
        </div>
      </div>
    </div>
  );
};

export default Index;













// import React, { useState, useRef } from 'react';
// import jsonData from '../../Utils/farmerImagesName.json';
// import html2canvas from 'html2canvas';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { useEffect } from 'react';
// import { getCookie, setCookie } from '../../Utils/cookies';
// import JSZip from "jszip";
// import { saveAs } from "file-saver";

// function importAllImages(r) {
//   return r.keys().map(r);
// }

// const Images = importAllImages(require.context('../../Assets/farmerPumpImages', false, /\.(png|jpe?g)$/));

// const Index = () => {

//   const Navigate = useNavigate();
//   useEffect(() => {
//     const token = getCookie('token');
//     if (!token) {
//       Navigate('/');
//     }
//   }, []);

//   const refs = useRef([]);
//   const totalImages = Images.length;
//   const [countOfDownloadedImages, setCountDownloadedImages] = useState(parseInt(getCookie('startCnt')));
//   const [endOfCountOfDownloadedImages, setEndOfCountOfDownloadedImages] = useState(parseInt(getCookie('endCnt')));
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [finalData, setFinalData] = useState([]);
//   const [selectedImages, setSelectedImages] = useState(Array(totalImages).fill(true));

//   const fetchData = async (index) => {
//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API_URL}/pump/showFarmer`, {
//         imageSaralId: jsonData[countOfDownloadedImages + index].original.split(".")[0],
//       });
//       const responseData = response.data;
//       if (responseData.success) {
//         console.log(responseData);
//         if(responseData.data === null){
//           return false;
//         }
//         return responseData.data;
//       }
//     } catch (error) {
//       console.error(`Error fetching data for index ${index}:`, error);
//       return null;
//     }
//   };

//   const fetchDataForSelectedImages = async () => {
//     const requests = selectedImages.map((isSelected, index) => {
//       const interval = setInterval(() => {
//         if (isSelected) {
//           let fetchedData = fetchData(index);
//           if(fetchedData)
//             fetchedData['indexing'] = index;
//           return fetchedData;
//         }
//         return null;
//       }, 100);
//       return () => clearInterval(interval)
//     });

//     const results = await Promise.all(requests);
//     console.log(results);
//     return results.filter(Boolean);
//   };


//   const downloadImagesAsZip = async () => {
//     setProgress(0);
//     const zip = new JSZip();
//     const imagesFolder = zip.folder("images");

//     for (let i = 0; i < refs.current.length; i++) {
//       const element = refs.current[i];
//       if (element) {
//         try {
//           const canvas = await html2canvas(element);
//           const dataURL = canvas.toDataURL("image/png");
//           const base64Data = dataURL.split(",")[1];
//           imagesFolder.file(`${jsonData[countOfDownloadedImages + i].original.split('.')[0]}.png`, base64Data, { base64: true });
//           canvas.remove();
//         } catch (error) {
//           console.error(`Failed to process image ${i + 1}:`, error);
//         }
//       }
//       setProgress(Math.round(((i + 1) / refs.current.length) * 100));
//     }

//     const zipBlob = await zip.generateAsync({ type: "blob" });
//     const objecURL = URL.createObjectURL(zipBlob);
//     saveAs(zipBlob, "images.zip");
//     URL.revokeObjectURL(objecURL);

//     setIsDownloading(false);
//     setProgress(0);
//     // setCountDownloadedImages((prev) => prev + 120);
//     setCookie('startCnt', countOfDownloadedImages + 120);
//     if (totalImages - endOfCountOfDownloadedImages >= 120) {
//       // setEndOfCountOfDownloadedImages((prev) => prev + 120);
//       setCookie('endCnt', endOfCountOfDownloadedImages + 120);
//     }
//     else {
//       const updatedValue = totalImages - endOfCountOfDownloadedImages;
//       setCookie('endCnt', updatedValue);
//       setEndOfCountOfDownloadedImages(updatedValue);
//     }
//     refs.current = [];
//     window.location.reload();
//   };

//   const handleDownload = async () => {
//     if (endOfCountOfDownloadedImages === totalImages) {
//       alert('Login again to download');
//     }
//     else {
//       setIsDownloading(true);
//       const fetchedData = await fetchDataForSelectedImages();
//       setFinalData(fetchedData);

//       // setTimeout(() => {
//       //   downloadImagesAsZip();
//       // }, 100);
//     }
//   };

//   const handleChangeCheckBoxes = (index) => {
//     const copyData = [...selectedImages];
//     copyData[index] = !copyData[index];
//     setSelectedImages(copyData);
//   }

//   const [isUploading, setIsUploading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [file, setFile] = useState();

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!file) {
//       setMessage('Please select a file to upload.');
//       return;
//     }
//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       setIsUploading(true);
//       setMessage('');
//       const response = await axios.post(`${process.env.REACT_APP_API_URL}/pump/excelUpload`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       setMessage(response.data.message);
//     } catch (error) {
//       console.log(error);
//       setMessage('Error uploading file.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   return (
//     <div className="container flex flex-col">
//       <div className="mainHeading">
//         <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg'>U<span className='text-lg'>PDATE</span> & D<span className='text-lg'>OWNLOAD</span> I<span className='text-lg'>MAGES</span></h1>
//       </div>
//       <div className="grid gap-3 m-6 md:grid-cols-4">
//         <div>
//           <div className='flex flex-row justify-between items-center'>
//             <form onSubmit={handleSubmit} >
//               <div>
//                 <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Choose File<span className='text-red-500 fixed h-3'>*</span></label>
//                 <input type="file" onChange={handleFileChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2 dark:bg-gray-700 " />
//               </div>
//               {message && (<p className="mt-4 ml-6 text-2xl text-left text-red-700"> {message} </p>)}
//             </form>
//             <div className='ml-2 mt-2.5'>
//               <button type="submit" disabled={isUploading} className="text-dark bg-yellow-500 mt-4 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center" onChange={handleFileChange}>
//                 {isUploading ? 'Uploading...' : 'Upload'}
//               </button>
//             </div>
//           </div>
//           <div>
//             <div>
//               <fieldset style={{ marginTop: '0.5rem' }}>
//                 <legend className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Saral Id<span className='text-red-500 fixed h-3'>*</span></legend>
//                 <section className="h-56 overflow-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
//                   {
//                     jsonData.map(({ split }, index) => (
//                       index >= countOfDownloadedImages && <div key={index} style={{ display: 'flex', width: 'min-content', gap: '4.5px' }}>
//                         <input type="checkbox" name="district" id={split} value={index} style={{ width: 'min-content' }} onChange={() => handleChangeCheckBoxes(index)} checked={(index >= countOfDownloadedImages && index < endOfCountOfDownloadedImages) ? true : false} />
//                         <label htmlFor={split} style={{ padding: '0px', fontSize: '12px', fontWeight: '400', width: 'max-content' }}>{split}</label>
//                       </div>
//                     ))
//                   }
//                 </section>
//               </fieldset>
//             </div>
//           </div>

//           <div style={{ position: "fixed", bottom: -9999, left: -9999, zIndex: -999 }}>
//             {finalData.map(({ saralId, beneficiaryName, installationDistrict, initialLongitude, initialLatitude, pumpCapacity }, index) => (
//               <div
//                 ref={(el) => (refs.current[index] = el)}
//                 key={index}
//                 style={{
//                   position: "relative",
//                   opacity: 1,
//                   pointerEvents: "none",
//                 }}
//               >
//                 <img
//                   src={Images[countOfDownloadedImages + index]}
//                   alt="Image"
//                   onLoad={(e) => {
//                     const img = e.target;
//                     const parentDiv = img.parentElement;
//                     const naturalWidth = img.naturalWidth;
//                     const naturalHeight = img.naturalHeight;

//                     parentDiv.style.width = `${naturalWidth}px`;
//                     parentDiv.style.height = `${naturalHeight}px`;

//                     const overlayDiv = parentDiv.querySelector(".overlay");
//                     if (overlayDiv) {

//                       if (naturalHeight > 950 || naturalWidth > 1800) {
//                         if (naturalWidth > 1800) {
//                           overlayDiv.style.width = `560px`;
//                         }
//                         else {
//                           overlayDiv.style.height = `282px`;
//                           overlayDiv.style.width = `550px`;
//                         }
//                         overlayDiv.style.fontSize = `24.5px`;
//                       }
//                       else {
//                         overlayDiv.style.width = `550px`;
//                         overlayDiv.style.height = `200px`;
//                         overlayDiv.style.fontSize = `19px`;
//                       }
//                     }
//                   }}
//                 />
//                 <div
//                   className="overlay"
//                   style={{ position: 'absolute', paddingLeft: 8, left: 0, bottom: 5, width: '480px', height: '200px', fontSize: '19px', background: 'rgba(200, 200, 200, 1)', color: '#000' }}
//                 >
//                   <div>
//                     <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Longitude: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{initialLongitude}</span>
//                   </div>
//                   <div>
//                     <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Longitude: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{initialLatitude}</span>
//                   </div>
//                   <div>
//                     <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>SaralId: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{saralId}</span>
//                   </div>
//                   <div>
//                     <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>Farmer Name: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{beneficiaryName}</span>
//                   </div>
//                   <div>
//                     <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>District: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{installationDistrict}</span>
//                   </div>
//                   <div>
//                     <span className='font-semibold tracking-widest' style={{ fontSize: 'inherit' }}>pumpCapacity: </span><span className='tracking-widest' style={{ fontSize: 'inherit' }}>{pumpCapacity}</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <button
//             onClick={handleDownload}
//             disabled={isDownloading}
//             className="bg-yellow-500 mt-4 text-dark font-medium rounded-sm text-sm px-5 py-2.5"
//           >
//             {isDownloading ? `Downloading... ${progress}%` : "Download Images"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Index;


